export const BUMP1_HOUR_LIMIT = 8;
export const BUMP2_HOUR_LIMIT = 8;
export const BUMP3_HOUR_LIMIT = 8;
export const BUMP4_HOUR_LIMIT = 8;
export const BUMP5_HOUR_LIMIT = 8;
export const BUMP_MINIMAL_WORKED_HOURS = 1;
export const BUMP_HOUR_DAILY_LIMIT = 24;
